import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  MockExamInteractionSchema,
  MockExamReduxSchema,
  SubjectMockExamReduxSchema,
} from "@tsTypes/redux-schema";
import {
  createMissingSubject,
  getBlankResource,
  isoStringToUnixDay,
} from "../../lib/redux/helpers";

const initialState: SubjectMockExamReduxSchema = {};

export const MockExamUserReduxMetadataSlice = createSlice({
  name: "MockExamUserReduxMetadata",
  initialState,
  reducers: {
    setMockExamState: (
      state,
      action: PayloadAction<
        | {
            [subjectDocumentId: string]:
              | {
                  [mockExamDocumentId: string]: MockExamReduxSchema;
                }
              | undefined;
          }
        | undefined
      >,
    ) => {
      return { ...action.payload };
    },
    mockExamAttempt: (
      state,
      action: PayloadAction<MockExamInteractionSchema>,
    ) => {
      const {
        subjectDocumentId,
        includedSubTopics,
        mockExamId,
        date,
        mcMarks,
        laMarks,
        numQuestions,
        percentagePerformance,
        percentageFree,
      } = action.payload;
      if (!state[subjectDocumentId]) {
        state[subjectDocumentId] = createMissingSubject();
      }
      if (!state[subjectDocumentId][mockExamId]) {
        state[subjectDocumentId][mockExamId] = getBlankResource(
          "mockExams",
        ) as MockExamReduxSchema;
      }
      // Overwrite draft meta above with correct data. Also handles case where question already existed and just needed updating
      state[subjectDocumentId][mockExamId].subTopicDocumentIds = [
        ...includedSubTopics,
      ];
      state[subjectDocumentId][mockExamId].mcMarks = mcMarks;
      state[subjectDocumentId][mockExamId].laMarks = laMarks;
      state[subjectDocumentId][mockExamId].numQuestions = numQuestions;
      state[subjectDocumentId][mockExamId].da.push(isoStringToUnixDay(date));
      state[subjectDocumentId][mockExamId].perf.push(percentagePerformance);
      state[subjectDocumentId][mockExamId].freeTimes.push(percentageFree);
    },
  },
});

export const { mockExamAttempt, setMockExamState } =
  MockExamUserReduxMetadataSlice.actions;

export default MockExamUserReduxMetadataSlice.reducer;
